
























































































































































































































































































































import Vue from 'vue'
import SmsAccount from '@/types/SmsAccount.interface'
import SignaturePad from 'signature_pad'
import printer from '@/plugins/printer'
import html2canvas from 'html2canvas'
import Tenant from '@/types/Tenant.interface'
import HostNumberInfo from '@/components/HostNumberInfo.vue'
interface HostingFormPayload {
    form: string
    carrier: string
    number: string
    signatureImg?: string
    signatureTxt?: string
}
export default Vue.extend({
    components: { HostNumberInfo },
    data: () => ({
        //  For our address field
        address: null,
        //  Keeps track of our active tab for signatures
        activeTab: 0,
        //  For our city field
        city: null,
        //  For our country field
        country: null,
        //  For our first name field
        firstName: null,
        //  For our last name field
        lastName: null,
        //  Tracks our loading state when uploading LOA
        loading: false,
        //  Container for our carrier IF they selected "Other"
        otherPhoneCarrier: null,
        //  For our phone carrier field
        phoneCarrier: null,
        //  For our phone number field
        phoneNumber: null,
        //  Our list of carriers to select from
        phoneNumberCarriers: [
            'AT&T',
            'Google Voice',
            'Spectrum',
            'Verizon',
            'T-Mobile',
            'Vonage',
            'Nextiva',
            'RingCentral',
            'Windstream',
            'Other'
        ],
        //  For our phone type field
        phoneType: 'USA',
        //  For our postal code field
        postalCode: null,
        //  Variable to keep track of our signature pad component
        signaturePad: null,
        //  Checks if we have inserted anything into our signature pad
        signatureSet: false,
        //  For our state field
        state: null,
        //  Keeps track of what step of our stepper we are on
        step: 1,
        //  Our LOA terms
        termsAccepted: null,
        //  For our signature field (when typing not drawing)
        typedSignature: null
    }),
    mounted() {
        //  Initialize our canvas
        this.initCanvas()
    },
    computed: {
        addressString(): string {
            //  If our form is incomplete, return null
            if (this.formIncomplete) return null

            //  Else, we have all of our value so lets format
            return `${this.address} ${this.city}, ${this.state} ${this.postalCode}`
        },
        countries() {
            return [
                {
                    display: 'US',
                    value: 'USA',
                    img: this.$images.usa
                },
                {
                    display: 'Canada',
                    value: 'CA',
                    img: this.$images.canada
                }
            ]
        },
        formattedNumber(): string {
            //  If we have no phone number yet, just return null
            if (!this.phoneNumber) return null

            //  Get our filter formatted number
            const phone = this.$options.filters.phone(this.phoneNumber)

            //  Prefix it with a +
            return `+1 ${phone}`
        },
        formIncomplete(): boolean {
            //  Make sure none of our values are null
            if (!this.firstName) return true
            if (!this.lastName) return true
            if (!this.country) return true
            if (!this.address) return true
            if (!this.city) return true
            if (!this.postalCode) return true
            if (!this.state) return true
            if (!this.signatureSet && !this.typedSignature) return true
            if (!this.termsAccepted) return true

            //  If none of the above pass, we are complete
            return false
        },

        phoneEmpty(): boolean {
            //  If there is no phone type, return true
            if (!this.phoneType) return true

            //  If there is no phone number, return true
            if (!this.phoneNumber) return true

            //  If we have no phone carrier, return true
            if (!this.phoneCarrier) return true

            //  If phone carrier is other and we haven't picked otherPhoneCarrier, return true
            if (this.phoneCarrier === 'Other' && !this.otherPhoneCarrier) return true

            //  Else, return false to proceed
            return false
        },
        phoneNumberTypes() {
            return [
                {
                    display: 'US Phone Number',
                    value: 'USA',
                    img: this.$images.usa
                },
                {
                    display: 'Canadian Phone Number',
                    value: 'Canada',
                    img: this.$images.canada
                },
                {
                    display: 'Toll-Free Number',
                    value: 'Toll-Free',
                    img: this.$images.telephone
                }
            ]
        },
        smsAccount(): SmsAccount {
            return this.$store.getters.smsAccount
        },
        snp() {
            //  Grab our states from the store
            const states = this.$store.getters.stateAbrvs

            //  Grab our provinces
            const provinces = this.$store.getters.provinces

            //  Grab the current country
            const country = this.country

            //  Based on the value we return a different value
            const rVal = {
                USA: states,
                CA: provinces
            }[country] || [...states, ...provinces]

            //  Return the above
            return rVal
        },
        tenant(): Tenant {
            return this.$store.getters.tenant
        }
    },
    methods: {
        clearInput(): void {
            //  Clear our text field
            this.typedSignature = null
        },
        clearPad(): void {
            //  Clear the signature pad
            this.signaturePad.clear()

            //  Reset our signature set var
            this.signatureSet = false
        },
        clearSignature(): void {
            //  Check our current tab
            const tab = this.activeTab

            //  Based on our tab, route to a different function
            return {
                0: () => this.clearPad(),
                1: () => this.clearInput()
            }[tab]()
        },
        async finalize(): Promise<void> {
            //  Start loading
            this.loading = true

            //  Get our hosting form as a data url
            const img = await this.getHostingFormUrl()

            //  Construct our payload for our request
            const payload = this.getHostingFormPayload(img)

            //  Get our form data for upload
            const formData = this.getHostingFormPdf(payload)

            //  Upload this to our media table
            const media = await this.$store.dispatch('mediaPost', formData)

            //  Our carrier depends on if we selected "Other" or not
            const carrier =
                this.phoneCarrier === 'Other' ? this.otherPhoneCarrier : this.phoneCarrier

            //  Construct our hosting payload
            const hostPayload = {
                address: this.addressString,
                //  We use ?. so this can actually fail, and if it does we stop loading
                media_id: media?.id,
                number: this.formattedNumber,
                provider: carrier
            }

            //  Report this for analytics (required for automation)
            await this.$store.dispatch('analyticsReportHosting', hostPayload)

            //  Finally done, so stop loading
            this.loading = false

            //  Go to the next page
            this.step = 4
        },
        getHostingFormPayload(img: string): HostingFormPayload {
            //  Our carrier depends on if we selected "Other" or not
            const carrier =
                this.phoneCarrier === 'Other' ? this.otherPhoneCarrier : this.phoneCarrier

            //  We also want to add carrier and phone number so make a payload
            const payload: HostingFormPayload = {
                form: img,
                carrier: carrier,
                number: this.phoneNumber
            }

            //  Check what our active tab is
            const tab = this.activeTab

            //  If our tab is 0 then we are getting the drawn signature
            if (tab === 0) payload.signatureImg = this.signaturePad.toDataURL()
            //  Else, our tab is 1 so we are getting the typed signature
            else {
                //  Grab our typed part
                payload.signatureTxt = this.typedSignature
            }

            //  Return our updated payload
            return payload
        },
        getHostingFormPdf(payload: HostingFormPayload): FormData {
            //  Create our PDF from this form
            const pdf = printer.drawLoa(payload)

            //  Grab the blob from this jsPDF
            const blob = pdf.output('blob')

            //  Get our current date in a readable format
            const date = new Date().toISOString()

            //  Create a name for our file
            const name = `MessageDesk_LOA_${date}`

            //  Create form data with this blob
            const formData = new FormData()
            formData.append('file', blob, name)

            //  Return our form data
            return formData
        },
        async getHostingFormUrl(): Promise<string> {
            //  Grab our hosting form element
            const form = document.getElementById('hosting-form')

            //  Convert this form into a canvas for our printer.js
            const canvas = await html2canvas(form)

            //  This is our form fields
            const url = canvas.toDataURL()

            //  Return our url
            return url
        },
        initCanvas(): void {
            //  Grab our Canvas element
            const canvas = document.getElementById('loa-signature') as HTMLCanvasElement

            //  If there is no element, do nothing
            if (!canvas) return

            //  Bind our signature pad to it
            this.signaturePad = new SignaturePad(canvas)

            //  Bind an event listener to track if it's been filled out
            this.signaturePad.addEventListener('endStroke', () => {
                //  Check if our pad has a value
                const empty = this.signaturePad.isEmpty()

                //  Set our state based on this
                this.signatureSet = !empty
            })
        },
        onTabChange(): void {
            //  If we changed tabs, just clear both signatures
            this.clearInput()
            this.clearPad()
        },
        popIntercomMessenger(): void {
            // Close help modal component
            this.$store.commit('helpModalSet', false)

            //  @ts-ignore If we are on the mobile app, then call our Cordova plugin
            if (this.isApp) intercom.displayMessenger()
            // Pops the intercom messenger through the id bound to the hidden span element
            else window.popSupportMessenger()
        },
        popPhoneCarrierTip(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Phone Carrier',
                text: "Enter your current phone provider or carrier below. Either select from the list or click 'Other' to enter your carrier manually"
            })
        },
        popPhoneNumberTip(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Phone Number',
                text: 'A list of available phone numbers that match the entered area code. If no numbers are available you can place a backorder request or search a different area code'
            })
        },
        popPhoneOtherCarrierTip(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Phone Carrier',
                text: 'Type the name of your current phone provider for the phone number entered above'
            })
        },
        popTerms(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'MessageDesk Letter of Authorization Terms',
                text: `By signing the below, I verify that I am, or represent (for a business), the above-named
service customer, authorized to change the primary carrier(s) for the telephone number(s)
listed, and am at least 18 years of age. The name and address I have provided is the name
and address on record with my local telephone company for each telephone number listed. I
authorize Alderwood Labs Inc. dba MessageDesk (the “Company”) or its designated agent to
act on my behalf and notify my current carrier(s) to change my preferred carrier(s) for the
listed number(s) and service(s), to obtain any information the Company deems necessary to
make the carrier change(s), including, for example, an inventory of telephone lines billed to
the telephone number(s), carrier or customer identifying information, billing addresses, and
my credit history.`
            })
        }
    },
    watch: {
        step() {
            //  Once step becomes 3, init our canvas
            if (this.step === 3) this.initCanvas()
        }
    }
})
